import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import MemberList from '../../../components/member/MemberList';
import { useSelector, useDispatch } from 'react-redux';
import {
  initialize,
  changeField,
  loadMemberList,
} from '../../../modules/commons/search';
import { withRouter } from 'react-router-dom';
import { setMemberID } from '../../../modules/member/member';
import { registItem } from '../../../modules/item/itemRegist';
import * as searchAPI from '../../../lib/api/search';
import qs from 'qs';

const MemberListContainer = ({
  history,
  location,
  initialPage = '1',
  initialSearchText = '',
}) => {
  const { members, paginationMembers, showMembers, memberCount, club, loading, form, socketKey, searchResult, clubLessonInfoData, clubMemberList } = useSelector(
    ({ search, club, loading, socket, clubLessonInfo }) => ({
      members: search.members,
      paginationMembers: search.paginationMembers,
      form: search.member,
      showMembers: search.showMembers,
      club: club.defaultClub,
      memberCount: search.memberCount,
      searchResult: search.searchResult,
      loading: loading[`search/LOAD_MEMBER_LIST`],
      userState: search.member.userState,
      socketKey: socket.socketKey,
      clubLessonInfoData: clubLessonInfo.clubLessonInfoData,
      clubMemberList: search.clubMemberList,
    }),
  );
  const dispatch = useDispatch();
  const [type, setType] = useState('registTime');
  const [modal, setModal] = useState(false);
  const [inputPage, setInputPage] = useState('');
  const [membershipTitle, setMembershipTitle] = useState('');
  const [membershipTitles, setMembershipTitles] = useState([]);
  const [memberState, setMemberState] = useState('');
  const [sex, setSex] = useState('');

  const parsedInitialPage = useMemo(() => {
    const numeric = Number(initialPage);
    return Number.isFinite(numeric) && numeric > 0 ? Math.floor(numeric) : 1;
  }, [initialPage]);
  const normalizedInitialKeyword = useMemo(() => {
    return typeof initialSearchText === 'string' ? initialSearchText : '';
  }, [initialSearchText]);

  const [page, setPage] = useState(parsedInitialPage);
  const [keyword, setKeyword] = useState(normalizedInitialKeyword);

  const updateUrl = useCallback(
    (nextPage, nextKeyword) => {
      if (!location) return;
      const queryObj = {};
      queryObj.page = nextPage;
      if (nextKeyword) {
        queryObj.searchText = nextKeyword;
      }
      const queryString = qs.stringify(queryObj, { encode: false });
      const basePath = '/member';
      const target = queryString ? `${basePath}?${queryString}` : basePath;
      const current = `${location.pathname}${location.search}`;
      if (current !== target) {
        history.push(target);
      }
    },
    [history, location],
  );

  const onChangePage = (nextPage) => {
    const numeric = Number(nextPage);
    const sanitized = Number.isFinite(numeric) && numeric > 0 ? Math.floor(numeric) : 1;
    if (sanitized !== page) {
      setPage(sanitized);
      updateUrl(sanitized, keyword);
    }
  };

  const lastLocationSearchRef = useRef(location ? location.search : '');

  useEffect(() => {
    const currentSearch = location ? location.search : '';
    if (currentSearch !== lastLocationSearchRef.current) {
      lastLocationSearchRef.current = currentSearch;
      setPage(parsedInitialPage);
      setKeyword(normalizedInitialKeyword);
      dispatch(
        changeField({
          form: 'member',
          type: 'keyword',
          keyword: normalizedInitialKeyword,
        }),
      );
    }
  }, [dispatch, location, parsedInitialPage, normalizedInitialKeyword]);

  useEffect(() => {
    if (form?.keyword !== keyword) {
      dispatch(
        changeField({
          form: 'member',
          type: 'keyword',
          keyword,
        }),
      );
    }
  }, [dispatch, form?.keyword, keyword]);

  useEffect(() => {
    if (!club || !socketKey) {
      return;
    }
    dispatch(
      loadMemberList({
        clubID: club.clubID,
        page,
        searchText: keyword,
        type,
        socketKey,
        membershipTitle,
        memberState,
        sex,
      }),
    );
  }, [club, dispatch, keyword, page, socketKey, type, membershipTitle, memberState, sex]);

  useEffect(() => {
    if (!club || !socketKey) {
      return;
    }
    let isMounted = true;
    const fetchMembershipTitles = async () => {
      try {
        const res = await searchAPI.loadClubMembershipTitles({
          clubID: club.clubID,
          socketKey,
        });
        if (
          isMounted &&
          res &&
          res.data &&
          Array.isArray(res.data.titles)
        ) {
          setMembershipTitles(res.data.titles);
        }
      } catch (e) {
        if (isMounted) {
          setMembershipTitles([]);
        }
      }
    };
    fetchMembershipTitles();
    return () => {
      isMounted = false;
    };
  }, [club, socketKey]);

  useEffect(() => {
    dispatch(initialize('member'));
  }, []);

  const onClick = (item) => {
    dispatch(setMemberID(item.playerID));

    history.push(`/member/@${item.playerID}?clubID=${club.clubID}`);
  };

  const onRegist = () => {
    history.push(`/member/regist`);
  };

  const onChangeSelect = (item) => {
    setType(item.value);
    setPage(1)

    console.log('onChangeSelect')
  };

  const onChangeMembershipTitle = (value) => {
    setMembershipTitle(value);
    setPage(1);
  };

  const onChangeMemberState = (value) => {
    setMemberState(value);
    setPage(1);
  };

  const onChangeSex = (value) => {
    setSex(value);
    setPage(1);
  };

  const modalHandler = useCallback(() => {
    setModal((prev) => {
      if (prev) {
        setInputPage('');
      }
      return !prev;
    });
  }, []);
  
  // Search part start
  const onChange = (e) => {
    const { name, value } = e.target;

    dispatch(
      changeField({
        form: 'member',
        type: name,
        keyword: value,
      }),
    );
  };

  const onSubmit = (e, text) => {
      e.preventDefault();

      if (page !== 1) {
        setPage(1)
      }
      setType('registTime')
      setMembershipTitle('')
      setMemberState('')
      setSex('')
      const trimmed = text ? text.trim() : '';
      setKeyword(trimmed)
      updateUrl(1, trimmed)

    console.log('onSubmit')
  }

  const onClickSearch = (text) => {
      if (page !== 1) {
        setPage(1)
      }
      setType('registTime')
      setMembershipTitle('')
      setMemberState('')
      setSex('')
      const trimmed = text ? text.trim() : '';
      setKeyword(trimmed)
      updateUrl(1, trimmed)

    console.log('onClickSearch')
  }


  const getAllUsers = useCallback(() => {
    if (club) {
      dispatch(initialize('member'));
      if (page !== 1) {
        setPage(1)
      }
      setType('registTime')
      setMembershipTitle('')
      setMemberState('')
      setSex('')
      setKeyword('')
      updateUrl(1, '')

      console.log('getAllUsers')
    }
  }, [club, dispatch, page, updateUrl]);

  //console.log('clubMemberList : ', clubMemberList)
  //console.log('club : ', club)

  return (
    <>
      <MemberList
        clubMemberList={clubMemberList}
        loading={loading}
        onClick={onClick}
        onRegist={onRegist}
        onChangeSelect={onChangeSelect}
        page={page}
        setPage={setPage}
        memberCount={memberCount}
        modalHandler={modalHandler}
        modal={modal}
        onChangePage={onChangePage}
        inputPage={inputPage}
        onSubmit={onSubmit}
        onChange={onChange}
        getAllUsers={getAllUsers}
        form={form}
        setInputPage={setInputPage}
        paginationMembers={paginationMembers}
        searchResult={searchResult}
        clubLessonInfoData={clubLessonInfoData}
        type={type}
        onClickSearch={onClickSearch}
        faceActive={club?club.faceActive:0}
        searchKeyword={keyword}
        membershipTitle={membershipTitle}
        membershipTitles={membershipTitles}
        onChangeMembershipTitle={onChangeMembershipTitle}
        memberState={memberState}
        onChangeMemberState={onChangeMemberState}
        sex={sex}
        onChangeSex={onChangeSex}
      />
    </>
  );
};

export default withRouter(MemberListContainer);
